// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__1ucaF","title":"card_title__2EX2M","inActive":"card_inActive__1OY5G"};